document.addEventListener('DOMContentLoaded', () => {
  const outtester = document.getElementsByClassName('scrolly');

  for (let i = 0; i < outtester.length; i++) {
    scrollification('scrolly', {
      i,
      scrollCont: '.carouselPre',
      itemsScroll: '.itemsC',
      customButtons: false, // set true only if you really have #left/#right inside this scrolly
      butLeft: '#left',
      butRight: '#right'
    });
  }

  /**
   * Initialize one carousel instance inside the nth .scrolly container
   */
  function scrollification(mainConter, setup = {}) {
    // Safe defaults (fixes the original default-param ReferenceError)
    const {
      i = null,
      scrollCont = '.carouselPre',
      itemsScroll = '.itemsC',
      customButtons = false,
      butLeft = '#left',
      butRight = '#right'
    } = setup;

    // Resolve container
    const outs = document.getElementsByClassName(mainConter);
    const out = (i == null) ? outs[0] : outs[i];
    if (!out) return;

    const itemElements = out.querySelectorAll(itemsScroll);
    const itemCount = itemElements.length;

    // Resolve track
    const scrollContainer = out.querySelector(scrollCont);
    if (!scrollContainer) return;

    // Enforce horizontal layout even if page CSS overrides it
    Object.assign(scrollContainer.style, {
      display: 'flex',
      flexDirection: 'row',
      gap: '12px',
      listStyle: 'none',
      margin: '0',
      padding: '0',
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      scrollSnapType: 'x mandatory'
    });

    // Ensure each slide has a fixed basis (prevents full-width stacking)
    itemElements.forEach(el => {
      el.style.flex = '0 0 clamp(220px, 32vw, 360px)';
      el.style.scrollSnapAlign = 'center';
      el.style.position = el.style.position || 'relative';
    });

    // Optional custom buttons
    if (customButtons === true) {
      const leftButton = out.querySelector(butLeft);
      const rightButton = out.querySelector(butRight);

      if (leftButton && rightButton) {
        // Hide buttons if there are fewer than 4 items
        if (itemCount < 4) {
          leftButton.style.display = 'none';
          rightButton.style.display = 'none';
        }

        const onBack = () => getBack();
        const onNext = () => getNext();

        if (typeof $ !== 'undefined') {
          $(leftButton).off('click').on('click', onBack);
          $(rightButton).off('click').on('click', onNext);
        } else {
          leftButton.addEventListener('click', onBack);
          rightButton.addEventListener('click', onNext);
        }
      }
    }

    // Scroll helpers
    function getNext() {
      for (let k = 0; k < itemElements.length; k++) {
        if (itemElements[k].getBoundingClientRect().left <= scrollContainer.getBoundingClientRect().left + 600) {
          const delta = itemElements[k].offsetWidth;
          if (typeof $ !== 'undefined') {
            $(scrollContainer).animate({ scrollLeft: $(scrollContainer).scrollLeft() + delta }, 250);
          } else {
            scrollContainer.scrollBy({ left: delta, behavior: 'smooth' });
          }
          break;
        }
      }
    }

    function getBack() {
      for (let k = 1; k < itemElements.length; k++) {
        if (itemElements[k].getBoundingClientRect().left < scrollContainer.getBoundingClientRect().left + 600) {
          const delta = itemElements[k - 1].offsetWidth;
          if (typeof $ !== 'undefined') {
            $(scrollContainer).animate({ scrollLeft: $(scrollContainer).scrollLeft() - delta }, 250);
          } else {
            scrollContainer.scrollBy({ left: -delta, behavior: 'smooth' });
          }
          break;
        }
      }
    }

    // ====== Video visibility / playback control ======
    const videos = out.querySelectorAll('.myVideo');

    function pauseAllVideos() {
      videos.forEach(video => {
        try { video.pause(); } catch (e) {}
      });
    }

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: [0.3, 0.5, 0.7, 0.9]
    };

    let currentlyPlayingVideo = null;

    const callback = (entries) => {
      const isMobile = window.innerWidth <= 890;

      // Determine the most visible video among the entries
      let highestVisibilityRatio = 0;
      let mostVisibleVideo = null;

      entries.forEach(entry => {
        if (entry.intersectionRatio > highestVisibilityRatio) {
          highestVisibilityRatio = entry.intersectionRatio;
          mostVisibleVideo = entry.target;
        }
      });

      if (highestVisibilityRatio >= 0.9 && mostVisibleVideo) {
        if (mostVisibleVideo !== currentlyPlayingVideo) {
          if (currentlyPlayingVideo) currentlyPlayingVideo.pause();

          const hasVideoSource = !!mostVisibleVideo.querySelector('source');

          if (isMobile) {
            pauseAllVideos();
            if (hasVideoSource) {
              mostVisibleVideo.play().catch(e => console.log('Video play error:', e));
              currentlyPlayingVideo = mostVisibleVideo;
            }
          } else {
            if (!mostVisibleVideo.hasAttribute('hover-listeners-added')) {
              mostVisibleVideo.setAttribute('hover-listeners-added', 'true');

              mostVisibleVideo.addEventListener('mouseover', () => {
                pauseAllVideos();
                if (hasVideoSource) {
                  mostVisibleVideo.play().catch(e => console.log('Video play error:', e));
                  currentlyPlayingVideo = mostVisibleVideo;
                }
              });

              mostVisibleVideo.addEventListener('mouseout', () => {
                if (hasVideoSource) mostVisibleVideo.pause();
                currentlyPlayingVideo = null;
              });
            }
          }
        }
      } else if (highestVisibilityRatio < 0.5 && currentlyPlayingVideo) {
        currentlyPlayingVideo.pause();
        currentlyPlayingVideo = null;
      }
    };

    const observer = new IntersectionObserver(callback, options);
    videos.forEach(video => observer.observe(video));

    // Re-evaluate visibility during/after scroll
    scrollContainer.addEventListener('scroll', () => {
      observer.disconnect();
      videos.forEach(video => observer.observe(video));

      clearTimeout(scrollContainer.scrollTimer);
      scrollContainer.scrollTimer = setTimeout(() => {
        observer.disconnect();
        videos.forEach(video => observer.observe(video));
      }, 50);
    });

    // ====== Mute / Unmute buttons (per card) ======
    out.querySelectorAll('.soundButton').forEach(button => {
      // The soundButton lives inside .itemsC; find its sibling .myVideo
      const video = button.closest('.itemsC')?.querySelector('.myVideo');

      if (video) {
        // Initial state
        video.setAttribute('muted', '');
        video.muted = true;
        button.innerHTML = '<i class="fas fa-volume-mute"></i>';
        button.classList.add('muted');

        button.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (video.hasAttribute('muted')) {
            video.removeAttribute('muted');
            video.muted = false;
            button.innerHTML = '<i class="fas fa-volume-up"></i>';
            button.classList.remove('muted');
          } else {
            video.setAttribute('muted', '');
            video.muted = true;
            button.innerHTML = '<i class="fas fa-volume-mute"></i>';
            button.classList.add('muted');
          }
        };
      }
    });
  }

  // ====== Marquee slogos (if present) ======
  const slogos = document.querySelector('.slogos');
  if (slogos) {
    const originalContent = slogos.innerHTML;
    slogos.innerHTML += originalContent;
    const singleSetWidth = slogos.scrollWidth / 2;
    const scrollSpeed = 50; // px/s
    const animationDuration = singleSetWidth / scrollSpeed;
    slogos.style.animationDuration = `${animationDuration}s`;
  }
});
